module.exports = __webpack_public_path__ + "img/zhizhen.3b58f219.png";